import { render, staticRenderFns } from "./session-calendar-item.vue?vue&type=template&id=a6965c68&"
import script from "./session-calendar-item.vue?vue&type=script&lang=ts&"
export * from "./session-calendar-item.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports